/* eslint-disable */
import React, { Component } from "react";

import { show } from "redux-modal";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { getEnums } from "../../utils/store/actions/survey.action";
import {
  getFund,
  updateFund,
  getAllIssuerSigners,
  getAllProductSigners,
} from "../../utils/store/actions/funds.actions";
import Cookies from "js-cookie";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import { Button, Card, CardContent, Paper } from "@material-ui/core";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import ModalFundAddParts from "../../components/Modal/ModalFundAddParts";
const styles = (theme: Theme) =>
  createStyles({
    input: {
      "&:focus": {
        outline: "none !important",
        border: "1px solid red",
      },
    },
    divInput: {
      borderRadius: "5px",
    },
    fundCards: {
      borderRadius: "12px",
      display: "flex",
      justifyContent: "space-between",
    },
    card: {
      borderRadius: "12px",
      margin: "1%",
      border: "1px solid #EAEDF7",
      boxShadow: "0px 2px 4px rgba(28, 41, 90, 0.0367952)",
      "&:hover": {
        cursor: "pointer",
        background: "#F5F6FF",
      },
    },
    createPart: {
      color: "white",
      backgroundColor: "#ae0064",
      margin: "1%",
      textTransform: "none",
    },
  });
class FundTab extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.getEnums();
    this.props.getFund().then(() => {
      this.setState({ fund: this.props.Funds.fund });
    });
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const fundPersonId = urlParams.get("id");
    this.props.getAllIssuerSigners(fundPersonId);
    this.props.getAllProductSigners(fundPersonId);
  }

  handlePartNav = (part: any) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const fundPersonId = urlParams.get("id");
    window.location.href = `/admin/parts/details/part?id=${fundPersonId}&partId=${part.id}`;
    Cookies.set("tab", "part");
  };
  render() {
    const { Funds, Surveys } = this.props;
    const { fund } = Funds;
    const { classes } = this.props;
    const { t } = this.props;

    return this.state.fund && Surveys.enums ? (
      <div style={{ width: "100%" }}>
        <ModalFundAddParts />
        {/* CONTENT */}
        <div className={classes.divInput}>
          {fund ? (
            <>
              <Button
                variant="contained"
                className={classes.createPart}
                onClick={() =>
                  this.props.show("create_update_part", {
                    name: "create_update_part",
                    history,
                    actionDone: "CREATE",
                  })
                }
              >
                {t("CREATE_PART")}
              </Button>
              <div>
                {Funds?.fund?.parts &&
                  Funds?.fund?.parts?.map((part: any) => {
                    return (
                      <Card
                        onClick={() => {
                          this.handlePartNav(part);
                        }}
                        key={part.id}
                        className={classes.card}
                      >
                        <CardContent id={part.id} className={classes.fundCards}>
                          <div>{part.name}</div>
                        </CardContent>
                      </Card>
                    );
                  })}
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    ) : (
      <Paper className={classes.paper}>
        <Loader
          type="ThreeDots"
          color="#4B0084"
          height={100}
          width={100}
          timeout={3000} //3 secs
        />
      </Paper>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getFund,
  updateFund,
  show,
  getEnums,
  getAllIssuerSigners,
  getAllProductSigners,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(FundTab)));
